import React, { FunctionComponent } from "react";
import { translate } from "../../../i18n/i18n";
import styles from "./AlertListHeader.module.scss";

export const AlertListHeader: FunctionComponent<{amount: number, embedded?:boolean}> = ({ amount, embedded }) => {
  return <h1 className={embedded === true ? styles.alertListHeader : `${styles.alertListHeader} ${styles.separate}`}>{translate(`alerts`)} <span
    className={styles.alertAmount}>{amount}</span></h1>
}